import axios from "axios";
import Config from "../utils/Config";

const axiosClient = axios.create({
  baseURL: Config.API_BASE_URL,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(Config.TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosClient;
